import { render } from "./EditLohnastusInfo.vue?vue&type=template&id=61f4146a&scoped=true"
import script from "./EditLohnastusInfo.vue?vue&type=script&lang=js"
export * from "./EditLohnastusInfo.vue?vue&type=script&lang=js"

import "./EditLohnastusInfo.vue?vue&type=style&index=0&id=61f4146a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f4146a"]])

export default __exports__